// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/view/settings/Menu15/Item.css
// module id = 2033
// module chunks = 0